/**
 * Post-processing debug breadcrumbs for manual test verification.
 *
 * Each call emits one greppable line: `[pp-debug] <event> <json>`. The line
 * goes through the electron-log renderer bridge when available, so with
 * LB_LOCAL_TRANSCRIPTION_POST_PROCESSING_DEBUG=1 (which enables the main
 * process file transport) every breadcrumb lands in
 * ~/Library/Logs/<app>/main.log and a test run can be verified from the file.
 * Without the bridge the line falls back to the devtools console.
 */

type ElectronLogBridge = {
  debug?: (...args: unknown[]) => void;
};

export function ppDebug(event: string, fields: Record<string, unknown> = {}) {
  if (import.meta.env.MODE === 'test') return;

  const line = `[pp-debug] ${event} ${JSON.stringify(fields)}`;
  const bridge = (window as { __electronLog?: ElectronLogBridge })
    .__electronLog;
  if (bridge?.debug) {
    bridge.debug(line);
    return;
  }
  // eslint-disable-next-line no-console -- debug fallback when the electron-log bridge is absent
  console.debug(line);
}
